import { render } from "./AddIngredients.vue?vue&type=template&id=0f77df0a&scoped=true"
import script from "./AddIngredients.vue?vue&type=script&lang=js"
export * from "./AddIngredients.vue?vue&type=script&lang=js"

import "./AddIngredients.vue?vue&type=style&index=0&id=0f77df0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f77df0a"]])

export default __exports__